import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Mission from '../components/Mission';
import Programs from '../components/Programs';
import Gallery from '../components/Gallery';
import Marquee from '../components/Marquee';
import Footer from '../components/Footer';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Marquee />
      <Hero />
      <Mission />
      <Programs />
      <Gallery />
      <Footer />
    </>
  );
};

export default Home;
